import { useState } from 'react'

export function useInlineEditorState() {
    const [item, setItem] = useState()

    return [item, setItem]
}

export default useInlineEditorState
